module.exports = __webpack_public_path__ + "static/media/icon_arrow_right_bgc_dark.a1264e76.svg";